import React, { useState, useEffect } from "react";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar.js";
import "./CollegeContainer.css";
import Tabs from "../../Components/Tabs/Tabs";
import VerticalTabs from "../../Components/Tabs/VerticalTabs";
import CollegeLogo from "../../Components/UserAvatar/CollegeLogo";
import "./CommonContainerStyles.css";
//Redux
import { connect } from "react-redux";
import StickyButton from "../../Components/Buttons/StickyButton.js";

// import ConfirmButton from "../../Components/Buttons/ConfirmButton";
// import CancelButton from "../../Components/Buttons/CancelButton";

// import { withRouter } from "react-router-dom";

function CollegeContainer({
  header,
  onAdd,
  tabPairs,
  tabs,
  children,
  onClickTab,
  ref,
  initialIndex,
  viewbookings,
  addable,
  user,
}) {
  let [st, setSt] = useState([]);
  useEffect(() => {
    checkProps(tabPairs);
  }, []);

  const getSideTabs = (activeIndex) => {
    const addNewTab = {
      text: (
        <>
          <span>Add new</span> <i className="md-mini mdi mdi-plus mdi-36px"></i>
          <span></span>
        </>
      ),
      // text: <><span>Add new</span> <i className="mdi mdi-plus" size="tiny"></i></>,
      key: "addNew",
      addNew: true,
    };

    var temp = addable ? [addNewTab] : [];

    if (!tabPairs) {
      tabPairs = [
        { tabKey: "tab 1", rn: "tab 1" },
        { tabKey: "tab 2", rn: "tab 2" },
      ];
    }

    for (var i = 0; i < tabPairs.length; i++) {
      var tab = {
        text: tabPairs[i].rn == "" ? "tab " + i : tabPairs[i].rn,
        key: tabPairs[i].tabKey,
        active: i == activeIndex ? true : false,
        expired_time: tabPairs[i].expired_time,
        campus_id: tabPairs[i].campus_id,
        onClick: () => {
          clickTab(tabPairs[i].tabKey);
        },
      };
      temp.push(tab);
    }

    return temp;
  };

  const checkProps = (tabPairs) => {
    // console.log('props', tabPairs)
  };

  var sideTabs = getSideTabs(initialIndex);

  //setSt(sideTabs)

  const deleteTab = (key) => {
    // console.log('in container', key)
  };

  const clickTab = (key, index) => {
    onClickTab(key);
    sideTabs = [];

    if (key === "addNew") {
      tabPairs.unshift({
        tabKey: tabPairs.length,
        rn: "unnamed",
      });
      index = 1;
    }
    sideTabs = addable ? getSideTabs(index - 1) : getSideTabs(index);
    setSt(sideTabs);
  };

  const swapTab = (key) => {
    if (key >= this.props.campuses.length) {
      localStorage.setItem("campus-Index", key);

      const current_campus = this.state.newCampuses[
        key - this.props.campuses.length
      ];
      this.setState(
        {
          current_campus: current_campus,
        },
        () => {
          this.setFieldsValue(current_campus);
        }
      );
    } else if (key == "addNew") {
      localStorage.setItem("campus-Index", this.props.campuses.length);
      this.addNewCampus();
    } else {
      for (var i = 0; i < this.props.campuses.length; i++) {
        if (this.props.campuses[i]._id == key) {
          localStorage.setItem("campus-Index", i);
          const current_campus = this.props.campuses[i];
          this.setState(
            {
              current_campus: current_campus,
            },
            () => {
              this.setFieldsValue(current_campus);
            }
          );
          break;
        }
      }
    }
  };

  const menuLogoBar =
    !user || !user.hasOwnProperty("personnel_email") ? (
      <SwitchMenuBar
        isViewAsCollege={true}
        viewbookings={viewbookings}
        isTeacherInfo={true}
      />
    ) : (
      <SwitchMenuBar
        isViewAsPersonnel={true}
        viewbookings={viewbookings}
        isTeacherInfo={true}
      />
    );

  return (
    <div className="page-container-outer">
      <div className="menu-logo-bar">{menuLogoBar}</div>
      <div className="page-container-main bg-photoregister">
        <div className="bg-gradient page-container-bg"></div>
        <div className="page-container-header">
          <div className="page-container-header-inner">
            {/* College logo will go here */}
            <CollegeLogo />
            <h1>{header}</h1>
          </div>
        </div>
        <div className="page-container-inner">
          {tabs ? <Tabs tabs={tabs} /> : null}
          <div className="d-flex">
            <form className="college-form gray-shadow-box">{children}</form>
            <div className="college-form-tabs">
              <VerticalTabs
                onClickFun={clickTab}
                tabs={st.length == 0 ? sideTabs : st}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <StickyButton/> */}
    </div>

    // <div>
    //   {/* Menu area */}
    //   <div className="menu-logo-bar">
    //     {/* BLOCK NOW, this menubar is using the teacher side one, still needs to change the content*/}
    //     <SwitchMenuBar isViewAsTeacher={true} />
    //   </div>

    //   <div className="auth-right d-lg-flex bg-photoregister bg-fix">
    //     <div className="bg-gradient"></div>

    //     {/* Body area */}

    //     <div className="profile-container profile-container-transparent resume-container-transparent">
    //       <div className="profile-content-card-area">
    //         <div className="tab-content clearfix">
    //           <div className="mt-4">
    //             <h1 className="mb-5 text-alignment">{header}</h1>

    //             <div className="availability-table college-container-body">
    //               {/* Tab bar: get dynamic tab bar info from props. Each page group will have the same tab info, just change the "active" status for each page */}
    //               <Tabs tabs={tabs} />

    //               {/* form content from props. Pending onSubmit function between Parent and Children page */}
    //               <div className="availability-table-body mb-0 mt-4 p-2">
    //                 <div className="availability-table-body-content h-100 allow-overflow">
    //                   <div className="college-form-main mb-6">
    //                     <div className="college-form-left">
    //                       <form className="college-form gray-shadow-box">
    //                         {props.children}
    //                       </form>
    //                       <div className="college-form-tabs">
    //                         <VerticalTabs tabs={sideTabs} onAdd={onAdd} />
    //                       </div>
    //                     </div>

    //                     {/* <div
    //                                                 className="college-form-right"
    //                                                 onClick={onAdd}
    //                                             >
    //                                                 <div className="college-add-new-button">
    //                                                     <i className="mdi mdi-plus"></i>
    //                                                 </div>
    //                                                 Add another
    //                                             </div> */}
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
}

const mapStateToProps = function (state, ownProps) {
  return {
    header: ownProps.header,
    onAdd: ownProps.onAdd,
    tabPairs: ownProps.tabPairs,
    tabs: ownProps.tabs,
    children: ownProps.children,
    onClickTab: ownProps.onClickTab,
    ref: ownProps.ref,
  };
};

export default connect(mapStateToProps)(CollegeContainer);
